import { DialogLike } from "@obg/mat.ui.core";

import { SMART_ID_LOGIN_DIALOG_ID } from "../../../src/login-flow-dialog/login-flow-dialog.const";

import { SmartIdLoginVerificationContainer } from "./smart-id-login-verification.container";

export const SMART_ID_VERIFICATION_DIALOG: DialogLike<SmartIdLoginVerificationContainer> = {
	dialogId: SMART_ID_LOGIN_DIALOG_ID,
	dialogComponentType: SmartIdLoginVerificationContainer,
};
